import { viewport_size } from "./helper";
const vp_size = viewport_size();

const body = document.body;

// ---------------- Menu Toggle Button ----------------
const btn = document.querySelector("#main-nav-toggle");
const nav = document.querySelector(".header__nav");

if (btn) {
  btn.addEventListener("click", function () {
    if (!body.classList.contains("main-nav-toggled")) {
      // Show nav
      body.classList.add("main-nav-toggled");
      btn.setAttribute("title", "Navigation ausblenden");
      btn.setAttribute("aria-label", "Navigation ausblenden");
      btn.setAttribute("aria-pressed", true);
      nav.style.maxHeight = "100vh";
    } else {
      // Hide nav
      body.classList.remove("main-nav-toggled");
      btn.setAttribute("title", "Navigation einblenden");
      btn.setAttribute("aria-label", "Navigation einblenden");
      btn.setAttribute("aria-pressed", false);
      nav.style.maxHeight = "0";
    }
  });
}

// ---------------- Animate submenus ----------------
const main_nav = document.querySelector(".nav.nav--header");
const overlay = document.querySelector("#content-overlay");
const v_size = viewport_size();

if (main_nav && vp_size.vw > 992) {
  const menu_items = main_nav.querySelectorAll(".menu-item");

  if (menu_items) {
    menu_items.forEach((item) => {
      let submenu = item.querySelector(".sub-menu-wrap");
      let has_submenu = item.classList.contains("menu-item-has-children")
        ? true
        : false;
      let is_submenu_item = item.parentNode.classList.contains("sub-menu")
        ? true
        : false;

      // Mouseenter => Show submenu
      item.addEventListener("mouseenter", () => {
        if (!is_submenu_item) hideAllSubMenus(); // Hide all other submenus if a menu item on the top level is hovered
        overlay.style.pointerEvents = "auto"; // Enable pointer events on overlay
        if (has_submenu) {
          body.classList.add("sub-menu-active");
          submenu.setAttribute("aria-hidden", false);
          submenu.style.maxHeight = `${submenu.scrollHeight}px`;
          if (v_size.vw > 992) {
            overlay.style.opacity = "1";
          }
        }
      });

      // Mouseleave => Hide submenu if there is one
      if (has_submenu) {
        submenu.addEventListener("mouseleave", () => {
          hideSubMenu(submenu);
        });
      }

      // Click on overlay => close submenu
      overlay.addEventListener("click", () => hideAllSubMenus());
    });
  }
}

// Helper function to hide submenu
function hideSubMenu(submenu) {
  if (!submenu) return;
  overlay.style.pointerEvents = "none"; // Disable pointer events on overlay
  if (body.classList.contains("sub-menu-active")) {
    body.classList.remove("sub-menu-active");
  }
  submenu.setAttribute("aria-hidden", true);
  submenu.style.maxHeight = `0px`;
  if (v_size.vw > 992) {
    overlay.style.opacity = "0";
  }
}

// Helper function to hide all submenus
function hideAllSubMenus() {
  document
    .querySelectorAll(".sub-menu-wrap")
    .forEach((submenu) => hideSubMenu(submenu));
}
